import React, { useState, useEffect } from 'react';
import './App.css'; // Import the CSS file for styling
import { firestore } from './firebase';
import { addDoc, Timestamp, collection} from "firebase/firestore";

const sounds = ["1. panemaan", "2. Anna kaasua", "3. riipasen kännin", "4. tilipäivä", "5. ui juma", "6. sateenkaari", "7. Trippailu tiedote", "8. Upsalanmittavin", "9. Plateu 3", "10. Kolisee huolella", "11. ei vittu kertaakaan", "12. Kahden kilon siika", "13. pingu noot noot", "14. puuhöylä", "15. Tonnin seteli", "16. Lailliset lääkkeet", "17. Se on hyvin jännä", "18. Kuis hurisee" ]

// Helper to generate a random hex color
function getRandomColor() {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

function Soundboard() {

  // State for managing button disabled status and countdown
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const cooldownDuration = 10; // Set the cooldown duration in seconds

  // Array of button labels
  const buttons = Array.from({ length: sounds.length }, (_, index) => `${sounds[index]}`);

  // useEffect to manage the countdown timer
  useEffect(() => {
    let timer;
    if (buttonsDisabled && countdown > 0) {
      // If buttons are disabled and countdown is active, start/continue the timer
      timer = setInterval(() => {
        setCountdown(prevCountdown => {
          if (prevCountdown <= 1) {
            // If it's the last second, clear the timer and re-enable buttons
            clearInterval(timer);
            setButtonsDisabled(false);
            return 0; // Reset countdown display
          }
          return prevCountdown - 1; // Decrement countdown
        });
      }, 1000); // Update every second
    } else if (countdown === 0 && buttonsDisabled) {
        // Edge case: if countdown somehow hits 0 while disabled, reset state
        setButtonsDisabled(false);
    }

    // Cleanup function: important to clear the interval when the component unmounts
    // or when the dependencies (buttonsDisabled, countdown) change, restarting the effect.
    return () => clearInterval(timer);
  }, [buttonsDisabled, countdown]); // Dependencies for useEffect

  async function playSound(label,index){
    if (buttonsDisabled) {
      console.log("Soundboard on cooldown!");
      return; // Prevent playing if disabled
    }
  //const idx = index +1
  console.log(`Playing ${label}`)

  // Set buttons to disabled and start the countdown
    setButtonsDisabled(true);
    setCountdown(cooldownDuration);


  try {
      await addDoc(collection(firestore, "soundboard"), {
        isPlayed: false,
        sound: sounds[index]
      });
      console.log("Sound played and logged to Firestore.");
    } catch (error) {
      console.error("Error logging sound to Firestore:", error);
      // Decide if you want to re-enable buttons immediately on error, or wait
      // For now, we'll keep cooldown active to prevent spam even on error
    }

    // Add a temporary visual effect on click directly in JS!
    const clickedButton = document.querySelector(`.sound-button[data-index="${index}"]`);
    if (clickedButton) {
      clickedButton.classList.add('clicked-effect');
      setTimeout(() => {
        clickedButton.classList.remove('clicked-effect');
      }, 500); // Remove the effect after 0.5 seconds
    }
};

  return (
      <div className="soundboard-wrapper"> {/* New wrapper for potential top-level styling */}
        {/* Display countdown timer if active */}
        {buttonsDisabled && countdown > 0 && (
          <div className="cooldown-timer">
            Soundboard cooling down: {countdown}s
          </div>
        )}

      <div className="soundboard">
        {buttons.map((label, index) => (
          <button
            key={index}
            className={`sound-button ${buttonsDisabled ? 'disabled-button' : ''}`} // Apply disabled class
            onClick={() => playSound(label, index)}
            //style={getDynamicButtonStyle(index)} // Apply dynamic inline styles
            data-index={index} // Add a data attribute to easily target in JS
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Soundboard;